import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const [login, setLogin] = useState(JSON.parse(localStorage.getItem("login")));
  const [token, setToken] = useState(JSON.parse(localStorage.getItem("token")));
  const [isManager, setIsManager] = useState(JSON.parse(localStorage.getItem("isManager")));

  useEffect(() => {
    localStorage.setItem("login", login);
    localStorage.setItem("isManager", isManager);
  }, []);

  return (token && isManager) ? <Outlet /> : <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />;
};

export default PrivateRoute;
